import { render, staticRenderFns } from "./OptOut.vue?vue&type=template&id=650c5b95&"
import script from "./OptOut.vue?vue&type=script&lang=js&"
export * from "./OptOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports